{
  "configurations_general_page": {
    "title": "Configurations",
    "description": "Turn SparkLayer features on or off and manage your store settings.",
    "footer": "Learn more about configurations",
    "actions": {
      "watch_tour": "Watch tour",
      "setup_assistance": "Free setup assistance"
    },
    "shopify_alert": {
      "title": "Looking for Shopify configurations?",
      "description": "You can now manage your Shopify configurations from the Integrations configuration section.",
      "action": "Go to Integrations"
    },
    "cards": {
      "features": {
        "title": "Features",
        "fields": {
          "company_users": {
            "label": "Enable company users",
            "description": "Allow your customers to create teams to share activities such as placing orders."
          },
          "quoting": {
            "label": "Enable quotes",
            "description": "Activate the SparkLayer Quoting Engine and streamline your quoting process."
          },
          "quote_statuses": {
            "label": "Quote statuses",
            "description": "Customise the statuses you use to manage your quotes."
          },
          "purchase_timeline": {
            "label": "Enable timeline & communications",
            "description": "Allow customers and sales agents to send messages and updates on quotes and orders."
          },
          "purchase_notifications": {
            "label": "Purchase notifications",
            "description": "Choose which email addresses are notified about quotes and orders."
          },
          "invoicing": {
            "label": "Enable invoices",
            "description": "Send invoices to your B2B customers directly through SparkLayer."
          },
          "invoice_settings": {
            "label": "Invoice settings",
            "description": "Customise the contents of your invoices."
          },
          "multi_location_stock": {
            "label": "Enable multi-location stock",
            "description": "Specify which stock (or \"inventory\") locations you want your customers to use stock from.",
            "sync_required": {
              "title": "Product sync needed",
              "description": "Stock locations are pulled in during a full product sync. Run one to bring this store's locations and their stock levels into SparkLayer.",
              "action": "Go to product sync"
            }
          },
          "tax_inclusive_display_enabled": {
            "label": "Enable tax-inclusive price display",
            "description": "Lets individual price lists show prices inclusive of tax, using a \"display_tax_rate\" percentage column in the pricing CSV. Changes what buyers see, not what they are charged."
          },
          "analytics": {
            "label": "Enable analytics",
            "description": "Lets sales agents see sales analytics on the Pulse dashboard."
          },
          "payments_visibility": {
            "label": "Enable payments visibility",
            "description": "Show the payment status of orders in the My Account area."
          },
          "recurring_orders": {
            "label": "Enable recurring orders",
            "description": "Activate the SparkLayer recurring orders feature."
          },
          "company_sections": {
            "label": "Enable company locations",
            "description": "Let customers who belong to a company choose which location of it they are purchasing for, applying that location's pricing."
          }
        }
      },
      "store_settings": {
        "title": "Store settings",
        "fields": {
          "store_details": {
            "label": "Store details",
            "description": "Customise the default settings for your store such as the store name."
          }
        }
      },
      "other_configurations": {
        "title": "Other configurations",
        "fields": {
          "apply_price_breaks_across_variants": {
            "label": "Apply tiered pricing across variants",
            "description": "If products have variants, tiered pricing will be applied across all available variants."
          },
          "purchase_id_affixes": {
            "label": "Internal purchase ID prefix/suffix",
            "description": "Set the prefix/suffix used on SparkLayer internal purchases (such as orders for approval, and quotes).",
            "placeholder": "#P"
          },
          "cart_search_type": {
            "label": "Cart search type",
            "description": "Customise how you want search to work within the SparkLayer Cart.",
            "options": {
              "basic": "SKU/barcode lookup",
              "full": "Search",
              "off": "Hide search"
            }
          },
          "custom_email_domain": {
            "label": "Custom email domain",
            "description": "Customise the user and domain used for outbound and inbound emails."
          },
          "hide_ai_cart_features": {
            "label": "Hide AI features from cart",
            "description": "Hides the AI Intelligent Cart features from the SparkLayer Cart view."
          }
        }
      }
    }
  },
  "quote_statuses_page": {
    "title": "Edit quote statuses",
    "description": "Configure your quote statuses below.",
    "footer": "Learn more about quote statuses",
    "add_status": "Add new status",
    "default_badge": "Default",
    "delete_modal": {
      "title": "Delete quote status",
      "message": "Are you sure you want to delete this quote status?"
    },
    "loophole": {
      "text": "The \"{editStatus}\" status allows editing and will move into the \"{completeStatus}\" status which allows completing.",
      "impact": "This will allow the customer to edit the quote and then complete the quote without any edits being reviewed."
    },
    "fields": {
      "display_name": {
        "label": "Quote status display name",
        "placeholder": "Awaiting Customer",
        "description": "This will be shown to customers when viewing a quote."
      },
      "handle": {
        "label": "Quote status handle (or ID)",
        "placeholder": "awaiting-customer",
        "description": "This will be used to identify the quote status."
      },
      "default": {
        "label": "Set as default quote status for customers",
        "description": "All new quotes will begin in this status."
      },
      "next": {
        "label": "What status should the quote move to when an edit is made?",
        "no_change": "No change in status"
      },
      "actions": {
        "label": "Actions allowed in this status"
      }
    },
    "actions": {
      "edit_quote": {
        "title": "Allow customers to make edits to quote",
        "description": "Customers can make changes to the quote if required."
      },
      "complete_quote": {
        "title": "Allow customers to complete quote",
        "description": "Customers can complete their quote and finalise their order."
      },
      "expiry_date": {
        "title": "Require an expiry date before changing to a new status",
        "description": "An expiry date must be set before changing to a new status."
      },
      "download_pdf": {
        "title": "Allow customers to download a PDF of the quote",
        "description": "Customers can download a PDF of the quote."
      }
    },
    "delete_tooltip": {
      "required": "This is a required quote status.",
      "default": "This is the default quote status.",
      "in_flow": "This status is used in a status flow.",
      "new": "This is a new status.",
      "delete": "Delete this quote status."
    },
    "errors": {
      "slug_invalid": "Quote status handle may only contain letters, numbers, dashes, and underscores.",
      "slug_taken": "Quote status handle is already in use."
    },
    "notifications": {
      "create_taken": "This quote status handle (ID) is already in use, please try again with a unique one.",
      "update_taken": "This quote status handle (ID) is taken, please try again with a unique one.",
      "not_found": "This quote status could not be found, please try again."
    }
  },
  "purchase_notifications_page": {
    "title": "Edit notifications",
    "description": "Choose which email addresses are notified when purchases update and there is no assignee.",
    "footer": "Learn more about purchase notifications",
    "recipients_card": {
      "title": "Recipients",
      "label": "Email addresses to notify",
      "description": "Enter one email per line for people to be notified when purchases update.",
      "placeholder": "your@email.com\nanother@email.com",
      "invalid": "Please enter only valid email addresses"
    },
    "advanced_card": {
      "title": "Advanced settings",
      "sending_domain": "Sending sub-domain",
      "sender_address": "Sender address {user}@{domain}",
      "using_custom_domain": "Your emails are currently sending from your verified sub-domain. To update your sub-domain settings or sender address, please contact our support team.",
      "own_domain": {
        "title": "Send from your own sub-domain",
        "description": "Improve brand recognition and deliverability by using your own sub-domain. Click below to start the setup with our team."
      }
    }
  },
  "invoice_settings_page": {
    "title": "Edit invoice settings",
    "description": "Manage the content that shows on the invoices your customers view and download from their account.",
    "footer": "Learn more about invoices",
    "card": {
      "title": "Invoice content",
      "description": "Content Zones allow you to add content into \"predefined sections\" of the invoice such as payment terms, bank details, tax details, terms and conditions, or anything else you may require your customers to see. Please note, Content Zones are optional and don't have to be filled in if you don't require them."
    },
    "content_zone": {
      "label": "Content Zone {index}",
      "title_placeholder": "Title",
      "content_placeholder": "Content"
    },
    "info_panel": "Looking to fully customise your invoices? Please contact our team to learn more about advanced invoice customisations."
  },
  "store_details_page": {
    "title": "Edit store details",
    "description": "SparkLayer automatically synchronises data from your eCommerce platform such as your store name and address.",
    "footer": "Learn more about store details",
    "card": {
      "title": "Summary"
    },
    "override": {
      "label": "Modify store data",
      "description": "Overwrite the default data that is synchronised."
    },
    "fields": {
      "store_name": {
        "label": "Store name",
        "placeholder": "B2B Demo Store"
      },
      "address": {
        "label": "Store address",
        "placeholder": "Address line 1"
      },
      "address_line_2": {
        "placeholder": "Address line 2"
      },
      "city": {
        "placeholder": "City"
      },
      "postcode": {
        "placeholder": "Postcode"
      },
      "region": {
        "placeholder": "Select a region"
      },
      "country": {
        "placeholder": "Select a country"
      },
      "phone": {
        "label": "Store phone number",
        "placeholder": "01234 456789"
      },
      "url": {
        "label": "Store website URL",
        "placeholder": "www.b2bstore.com"
      },
      "email": {
        "label": "Store email",
        "placeholder": "store@b2bstore.com"
      }
    },
    "update_settings": "Update settings"
  }
}
